const MerchentServiceCharge = (price: number, store: any) => {

  const store_domain_setting = store?.domain_setting || {};

  // return store?.domain_setting?.is_merchant == 1
  //   ? (price * parseFloat(store?.domain_setting?.mer_service_charge)) / 100 < parseFloat(store?.domain_setting?.mer_min_service_charge)
  //     ? store?.domain_setting?.mer_min_service_charge
  //     : (Number(price) * parseFloat(store?.domain_setting?.mer_service_charge)) / 100 > parseFloat(store?.domain_setting?.mer_max_service_charge)
  //     ? store?.domain_setting?.mer_max_service_charge
  //     : (price * parseFloat(store?.domain_setting?.mer_service_charge)) / 100
  //   : 0;
  if (store_domain_setting?.is_merchant != 1) {
    return 0
  }
  let merCharge = 0;
  let min_service_charge = (store_domain_setting?.mer_min_service_charge);
  let max_service_charge = (store_domain_setting?.mer_max_service_charge);
  let service_charge = (price * parseFloat(store_domain_setting?.mer_service_charge)) / 100;

  if (min_service_charge == 0 && max_service_charge == 0) {
    merCharge= service_charge
  } else if (min_service_charge == 0 && max_service_charge > 0) {
    merCharge = service_charge > max_service_charge ? max_service_charge : service_charge
  } else if (min_service_charge > 0 && max_service_charge == 0) {
    merCharge = service_charge < min_service_charge ? min_service_charge : service_charge
  }
  // console.log('merChargemerCharge', merCharge)
  return merCharge;


};
export default MerchentServiceCharge;


